var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.664,
    height: 9.785,
    viewBox: "0 0 12.664 9.785",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_871",
    "data-name": "Trazado 871",
    d: "M15.1,8.427a.509.509,0,0,1,.366.466v5.753a.549.549,0,0,1-.42.485,9.629,9.629,0,0,1-5.847.008,9.354,9.354,0,0,0-2.948-.479,8.683,8.683,0,0,0-2.617.442.568.568,0,0,1-.312,0A.5.5,0,0,1,3,14.646V6.976a.549.549,0,0,1,.42-.485,9.64,9.64,0,0,1,5.847-.008,10.438,10.438,0,0,0,1.252.332,8.686,8.686,0,0,0,4.313-.294l.089-.021a.48.48,0,0,1,.191.938l-.046.015a9.641,9.641,0,0,1-5.87.015,9.413,9.413,0,0,0-2.711-.479,8.649,8.649,0,0,0-2.521.337L3.959,14a9.6,9.6,0,0,1,5.309.149,9.045,9.045,0,0,0,5.231.141l.006-5.4s.126-.556.593-.466Zm-2.007,4.312a.5.5,0,0,1,.364.76.8.8,0,0,1-.623.223,9.3,9.3,0,0,1-1.7-.024.506.506,0,0,1-.422-.668.544.544,0,0,1,.58-.279,8.45,8.45,0,0,0,1.727-.009A.47.47,0,0,1,13.091,12.739ZM9.244,8.9a1.964,1.964,0,0,1,1.865,1.56,1.958,1.958,0,0,1-2.226,2.227A1.91,1.91,0,0,1,9.195,8.9Zm-.019.959a.951.951,0,1,0,.365,1.831.983.983,0,0,0,.482-1.323.968.968,0,0,0-.823-.508H9.226ZM6.387,7.945A9.2,9.2,0,0,1,7.335,8c.1.012.426.158.456.428a.5.5,0,0,1-.51.531,10.554,10.554,0,0,0-1.834,0,.622.622,0,0,1-.384-.133A.494.494,0,0,1,5.328,8,7.4,7.4,0,0,1,6.387,7.945Z",
    transform: "translate(-2.9 -5.918)",
    fill: "#e73758",
    stroke: "#e73758",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarBill);
export default __webpack_public_path__ + "static/media/dollar-bill.7f4125c3c8790a0d55ea98ecf44d355f.svg";
export { ForwardRef as ReactComponent };